import React from 'react'
import NavLink from '../Routes/NavLink'


import WorkOrdersList from '../WorkOrders/WorkOrdersList'

export default class WorkOrdersWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="card">
                <div class="header">
                    <h4 class="title">Maintenance Request for Today</h4>
                    <p class="category">See a snapshot of the latest maintenance requests today</p>
                </div>
                <div class="content">
                    <div class="row">
                        <div class="col-md-12">
                            <WorkOrdersList orderFilter={"All"} sortOptions={"AND (YEAR(created_at) = YEAR(CURRENT_DATE()) AND MONTH(created_at) = MONTH(CURRENT_DATE()) AND DAY(created_at) = DAY(CURRENT_DATE()) OR YEAR(created_at) = YEAR(CURRENT_DATE()) AND MONTH(created_at) = MONTH(CURRENT_DATE()) AND DAY(created_at) = DAY(CURRENT_DATE() - 1) ) LIMIt 5"} tableType={"widget"}/>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="footer">
                        <div class="legend">
                            <NavLink to={"/maintenance/"}>
                            <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off" >
                            View All
                            </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/WorkOrders/WorkOrdersWidget.jsx